module.exports = __webpack_public_path__ + "static/media/image-tuesday.6065c4bf.jpg";